import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './button';

const PAGE_SIZE_OPTIONS = [20, 50, 100, 500, 1000];

export function TablePagination({ 
  page, 
  totalPages, 
  total = 0,
  limit = 20, 
  onPageChange, 
  onLimitChange,
  showPageSizeSelector = true 
}) {
  const startItem = total > 0 ? (page - 1) * limit + 1 : 0;
  const endItem = Math.min(page * limit, total);

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 border-t bg-white">
      <div className="flex items-center gap-4">
        <p className="text-sm text-slate-500">
          Showing <span className="font-medium">{startItem}</span> to <span className="font-medium">{endItem}</span> of <span className="font-medium">{total}</span> results
        </p>
        
        {showPageSizeSelector && onLimitChange && (
          <div className="flex items-center gap-2">
            <span className="text-sm text-slate-500">Per page:</span>
            <select
              value={limit}
              onChange={(e) => {
                onLimitChange(Number(e.target.value));
                onPageChange(1); // Reset to first page when changing limit
              }}
              className="h-9 px-2 py-1 text-sm border border-slate-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent cursor-pointer"
              data-testid="page-size-selector"
            >
              {PAGE_SIZE_OPTIONS.map(size => (
                <option key={size} value={size}>{size}</option>
              ))}
            </select>
          </div>
        )}
      </div>
      
      <div className="flex items-center gap-2">
        <p className="text-sm text-slate-500 mr-2">
          Page <span className="font-medium">{page}</span> of <span className="font-medium">{Math.max(1, totalPages)}</span>
        </p>
        <Button 
          variant="outline" 
          size="sm" 
          disabled={page <= 1} 
          onClick={() => onPageChange(page - 1)}
          data-testid="pagination-prev"
        >
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <Button 
          variant="outline" 
          size="sm" 
          disabled={page >= totalPages || totalPages <= 1} 
          onClick={() => onPageChange(page + 1)}
          data-testid="pagination-next"
        >
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
